var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-value-container"},[_c('h3',{staticClass:"label"},[_vm._t("label",[_c('span',[_vm._v(_vm._s(_vm.label))])])],2),_c('div',{staticClass:"value"},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }